export const ROOT_PATH_AUTH = 'auth';

export const AuthRoutes = {
  LOGIN: { path: 'login', fullPath: `/${ROOT_PATH_AUTH}/login` },
  REGISTER: { path: 'register', fullPath: `/${ROOT_PATH_AUTH}/register` },
  FORGOT_PASSWORD: { path: 'forgot-password', fullPath: `/${ROOT_PATH_AUTH}/forgot-password` },
};
